import React from 'react';
import $ from 'jquery';
import _ from 'lodash';
import numeral from 'numeral';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import SelectComponent from '../../shared_components/SelectComponent';
import InputComponent from '../../shared_components/InputComponent';
import DropDown from '../../../semantic_select_modules/semantic/components/dropdown';
import Transition from '../../../semantic_select_modules/semantic/components/transition';
import SelectCustom from '../../../semantic_select_modules/terugkerendeElementen/form/select';
import SemanticSelectCustom from '../../../semantic_select_modules/terugkerendeElementen/form/semanticSelect';
import InformationBoxComponent from '../../shared_components/InformationBoxComponent';
import AddDifferenceToLoanpartComponent from './AddDifferenceToLoanpartComponent';
import TrashBinComponent from '../../shared_components/TrashBinComponent';

@observer
class LoanpartRowComponent extends React.Component {
  constructor(props) {
    super(props);

    this.setLoanpart = this.setLoanpart.bind(this);
    this.setLoanpartPostDataObject = this.setLoanpartPostDataObject.bind(this);
    this.setloanpartsPostData = this.setloanpartsPostData.bind(this);
    this.resetFixedRateTermPostData = this.resetFixedRateTermPostData.bind(this);
    this.resetInterestPostData = this.resetInterestPostData.bind(this);
    this.getFixedRateTermsForLabel = _.debounce(this.getFixedRateTermsForLabel.bind(this), 600);
    this.getLabelInterest = _.debounce(this.getLabelInterest.bind(this), 600);
    this.setDefaultInterest = this.setDefaultInterest.bind(this);
    this.showTextBox = this.showTextBox.bind(this);
    this.resetFixedRateTermTextField = this.resetFixedRateTermTextField.bind(this);
  }

  componentWillMount() {
    this.setLoanpartPostDataObject();
  }

  componentDidMount() {
    /* Initialize semantic select ui after router did mount. */
    DropDown($, window, document, undefined);
    Transition($, window, document, undefined);
    SelectCustom.init();
    SemanticSelectCustom.init();
  }

  /* Calculate loanpart based on other loanparts */
  setLoanpart(event) {
    this.props.CalculationFormData.setLoanpart(event, this.props.index);

    if (this.props.CalculationOutputData.mortgageLoanpartsDifference) {
      this.props.CalculationOutputData.setMortgageLoanpartsDifference();
    }
  }

  /*
  *
  * Setup post data
  *
  * */

  /* Set loanpart object */
  setLoanpartPostDataObject() {
    const { setAvailableFixedRateTerms, getFixedRateTermsForLabel } = this.props.CalculationFormData;
    const { loanpartsPostData, labelsInterests } = this.props.CalculationFormData.mortgageForm;
    const { mortgageTypeFromOverview, labelIdFromUrl } = this.props.CalculationFormData;
    let interest = '-';

    /* For now give each loanpart an interest value based on a label id and nothing else */
    if (labelsInterests.length > this.props.index) {
      interest = labelsInterests[this.props.index].initialInterest;
    }

    loanpartsPostData[this.props.index] = {
      gross: '',
      frt: 20,
      loanpartDuration: '360',
      mortgageType: (labelIdFromUrl && mortgageTypeFromOverview) || '6',
      interest,
    };

    getFixedRateTermsForLabel(this.props.index).then(() => {
      setAvailableFixedRateTerms(this.props.index, loanpartsPostData[this.props.index].frt);
      this.setDefaultInterest();
    });
  }

  getFixedRateTermsForLabel(index) {
    const { getFixedRateTermsForLabel } = this.props.CalculationFormData;

    return getFixedRateTermsForLabel(index);
  }

  getLabelInterest(index) {
    const { getLabelInterest } = this.props.CalculationFormData;

    getLabelInterest(index);
  }

  setDefaultInterest() {
    const { getLabelInterest } = this.props.CalculationFormData;
    const { defaultInterest } = this.props.CalculationFormData.mortgageForm;
    const { loanpartsPostData } = this.props.CalculationFormData.mortgageForm;

    if (defaultInterest) {
      loanpartsPostData[this.props.index].interest = defaultInterest;
    }

    getLabelInterest(this.props.index, ((initialInterest) => {
      this.props.CalculationFormData.mortgageForm.defaultInterest = Number(initialInterest);
      loanpartsPostData[this.props.index].interest = Number(initialInterest);
    }));
  }

  /* Set props for a loanpart */
  setloanpartsPostData(event) {
    const { loanpartsPostData } = this.props.CalculationFormData.mortgageForm;
    loanpartsPostData[this.props.index][event.target.name] = Number(event.target.value);

    /* Get fixed rate terms when changing mortgageType */
    if (event.target.name === 'mortgageType') {
      this.getFixedRateTermsForLabel(this.props.index);

      this.resetInterestPostData(loanpartsPostData, this.props.index);
      this.resetFixedRateTermPostData(loanpartsPostData, this.props.index, loanpartsPostData);
    }

    if (event.target.name === 'loanpartDuration') {
      this.resetInterestPostData(loanpartsPostData, this.props.index);
      this.resetFixedRateTermPostData(loanpartsPostData, this.props.index, loanpartsPostData);
    }

    if (event.target.name === 'frt') {
      this.props.CalculationFormData.mortgageForm.fixedRateTerm = Number(event.target.value);
      this.getLabelInterest(this.props.index);
      this.getFixedRateTermsForLabel(this.props.index);
    }
  }

  resetInterestPostData(loanpartsPostData, index) {
    loanpartsPostData[index].interest = '-';
  }

  resetFixedRateTermPostData(loanpartsPostData, index, text) {
    loanpartsPostData[index].frt = '';
    this.props.CalculationFormData.setSelectText(index, text);
  }

  resetFixedRateTermTextField(index, text) {
    $(`.frt-${index} select[name=frt]`)
      .siblings('.text')
      .text(text);
  }

  showTextBox(data, event) {
    event.stopPropagation();
    this.props.ModalData.openModal(data);
  }

  render() {
    const {
      loanpartDurationLabels,
      mortgageTypes,
      errorFieldKeys,
    } = this.props.CalculationFormData;

    const {
      mortgageLoanpartsDifference,
      mitigateDifferenceMortgageLoanparts,
      removeLoanpart,
    } = this.props.CalculationOutputData;

    const { loanpartsPostData, fixedRateTerms } = this.props.CalculationFormData.mortgageForm;
    const { frt, loanpartDuration, mortgageType } = loanpartsPostData[this.props.index];
    const { informationBoxData } = this.props.InformationBoxData;
    let { interest } = loanpartsPostData[this.props.index];
    const currency = true;
    let frtLabels = [];

    /* FixedRateTerm  can never be higher than loanpartDuration */
    if (fixedRateTerms.length > this.props.index && fixedRateTerms[this.props.index]) {
      const selectedLoanpartDuration = loanpartDurationLabels
        .find(label => label.id === Number(loanpartDuration));

      if (selectedLoanpartDuration) {
        frtLabels = fixedRateTerms[this.props.index]
          .map(term => ({ id: term, name: `${term} Jaar`, value: Number(term) }))
          .filter(term => term.value <= selectedLoanpartDuration.value / 12);
      } else {
        frtLabels = [];
      }
    }

    /* If fixedRateTerms is empty, clear text field */
    if (fixedRateTerms.length > this.props.index && !frt) {
      const { defaultSelectText } = this.props.CalculationFormData;
      this.resetFixedRateTermTextField(this.props.index, defaultSelectText);
    } else {
      this.resetFixedRateTermTextField(this.props.index, `${frt} Jaar`);
    }

    /* Format interest */
    if (!isNaN(interest)) {
      interest = numeral(interest / 100).format('%0.00');
    }

    return (
      <div className="calculation-form_loanpart">
        <div className="row">
          <div className="columns calculation-form_loanpart__label">
            <label htmlFor="leningdeel">Leningdeel {this.props.index + 1} </label>
            <TrashBinComponent
              show={this.props.index > 0}
              onClickHandler={() => {
                removeLoanpart(this.props.index);
              }}
              classNames={'remove-loanpart-trashbin'}
            />
          </div>
        </div>
        <div className="row">
          <div className="medium-18 columns">
            <InputComponent
              value={this.props.value}
              onChangeHandler={this.setLoanpart}

              placeholder={'Hoogte leningdeel'}
              label={'Hoogte leningdeel'}
              currency={currency}
            >
              <InformationBoxComponent
                classNames="info-box-input"
                onClickHandler={(event) => { this.showTextBox(informationBoxData.loanPartValue, event); }}
              />
              <AddDifferenceToLoanpartComponent
                show={mortgageLoanpartsDifference && mortgageLoanpartsDifference !== 0}
                mortgageLoanpartsDifference={mortgageLoanpartsDifference}
                grossValue={this.props.value}
                onClickHandler={() => {
                  mitigateDifferenceMortgageLoanparts(mortgageLoanpartsDifference, this.props.index);
                }}
              />
            </InputComponent>
          </div>
          <div className="medium-18 columns">
            <SelectComponent
              labels={mortgageTypes}
              name="mortgageType"
              onChangeHandler={this.setloanpartsPostData}
              selected={mortgageType}

              label={'Aflosvorm'}
              errorFieldKeys={errorFieldKeys}
            >
              <InformationBoxComponent
                classNames="info-box-select"
                onClickHandler={(event) => { this.showTextBox(informationBoxData.mortgageType, event); }}
              />
            </SelectComponent>
          </div>
          <div className="medium-18 columns">
            <SelectComponent
              labels={loanpartDurationLabels}
              name="loanpartDuration"
              onChangeHandler={this.setloanpartsPostData}
              selected={loanpartDuration}
              classNames={`loanpart-duration-${this.props.index}`}
              label={'Looptijd leningdeel'}
              errorFieldKeys={errorFieldKeys}
            >
              <InformationBoxComponent
                classNames="info-box-select"
                onClickHandler={(event) => { this.showTextBox(informationBoxData.loanPartDuration, event); }}
              />
            </SelectComponent>
          </div>
          <div className="medium-18 columns">
            <SelectComponent
              labels={frtLabels}
              name="frt"
              onChangeHandler={this.setloanpartsPostData}
              selected={frt}
              classNames={` frt-${this.props.index}`}
              label={'Rentevaste periode'}
              errorFieldKeys={errorFieldKeys}
            >
              <InformationBoxComponent
                classNames="info-box-select"
                onClickHandler={(event) => { this.showTextBox(informationBoxData.frtPeriod, event); }}
              />
            </SelectComponent>
          </div>
          <div className="medium-12 columns">
            <InputComponent

              value={interest}label={'Rente'}
              placeholder={'Rente'}
            >
              <InformationBoxComponent
                classNames="info-box-input"
                onClickHandler={(event) => { this.showTextBox(informationBoxData.interest, event); }}
              />
            </InputComponent></div>
        </div>
      </div>
    );
  }
}

LoanpartRowComponent.propTypes = {
  CalculationOutputData: PropTypes.shape({
    setMortgageLoanpartsDifference: PropTypes.func,
    mortgageLoanpartsDifference: PropTypes.number,
    mitigateDifferenceMortgageLoanparts: PropTypes.func,
    removeLoanpart: PropTypes.func,
  }),
  CalculationFormData: PropTypes.shape({
    errorFieldKeys: PropTypes.arrayOf(PropTypes.shape({})),
    defaultSelectText: PropTypes.string,
    labelIdFromUrl: PropTypes.shape({}),
    mortgageTypeFromOverview: PropTypes.number,
    getFixedRateTermsForLabel: PropTypes.func,
    getLabelInterest: PropTypes.func,
    setSelectText: PropTypes.func,
    setAvailableFixedRateTerms: PropTypes.func,
    loanpartDurationLabels: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
    mortgageTypes: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
    mortgageForm: PropTypes.shape({
      defaultInterest: PropTypes.number,
      fixedRateTerm: PropTypes.number,
      mortgageType: PropTypes.number,
      loanparts: PropTypes.arrayOf(PropTypes.number),
      loanpartsPostData: PropTypes.arrayOf(PropTypes.shape({})),
      fixedRateTerms: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
      labelsInterests: PropTypes.arrayOf(PropTypes.shape({
        initialInterest: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),
      })),
    }),
    setLoanpart: PropTypes.func,
  }).isRequired,
  InformationBoxData: PropTypes.shape({
    informationBoxData: PropTypes.shape({
      header: PropTypes.string,
      text: PropTypes.string,
    }),
  }),
  ModalData: PropTypes.shape({
    openModal: PropTypes.func,
  }),
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  index: PropTypes.number,
};

LoanpartRowComponent.defaultProps = {
  CalculationOutputData: {
    setMortgageLoanpartsDifference: () => {},
    mortgageLoanpartsDifference: 0,
    mitigateDifferenceMortgageLoanparts: () => {},
    removeLoanpart: () => {},
  },
  CalculationFormData: {
    errorFieldKeys: [],
    defaultSelectText: '',
    labelIdFromUrl: {},
    mortgageTypeFromOverview: 0,
    getFixedRateTermsForLabel: () => {},
    setSelectText: () => {},
    getLabelInterest: () => {},
    setAvailableFixedRateTerms: () => {},
    loanpartDurationLabels: [],
    mortgageTypes: [],
    mortgageForm: {
      defaultInterest: 0,
      mortgageType: '',
      fixedRateTerm: '',
      loanparts: [],
      loanpartsPostData: [{
        frt: '',
        interest: '',
        loanpartDuration: '',
        mortgageType: '',
      }],
      fixedRateTerms: [],
    },
    setLoanpart: () => {},
  },
  InformationBoxData: {
    informationBoxData: {
      header: '',
      text: '',
    },
  },
  ModalData: {
    openModal: () => {},
  },
  value: 0,
  index: '',
};


export default inject('CalculationFormData',
                      'CalculationOutputData',
                      'InformationBoxData',
                      'ModalData')(LoanpartRowComponent);
